import React, { Component } from 'react';
import ServiceListItem from './ServiceListItem';

import List from 'material-ui/List';
import Grid from 'material-ui/Grid';
import Hidden from 'material-ui/Hidden';
import Table, { TableCell, TableHead, TableRow } from 'material-ui/Table';
import Paper from 'material-ui/Paper';
import Typography from 'material-ui/Typography';

class ServiceList extends Component {

  render() {
    return (
      <Grid item xs={12}>
        <Grid item xs={12} className='serviceList'>
          <Paper>
            <Table>
              <TableHead className='heading'>
                <TableRow>
                  <TableCell>
                    <Typography variant="display1">
                      Usluge
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </Paper>
        </Grid>
        <Hidden smDown>
          <List component="nav" className='desktopDockedList'>
            { this.props.services.map(service =>
              <ServiceListItem
                service={service}
                selectService={this.props.selectService}
                key={service.id}
                selectedService={this.props.selectedService}
              />
            )}
          </List>
        </Hidden>
        <Hidden mdUp>
          <List component="nav">
            { this.props.services.map(service =>
              <ServiceListItem
                service={service}
                selectService={this.props.selectService}
                key={service.id}
                selectedService={this.props.selectedService}
                mobileSize={true}
              />
            )}
          </List>
        </Hidden>
      </Grid>
    )
  }
}

export default ServiceList;



// WEBPACK FOOTER //
// ./src/components/ServiceList.js